import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ThreadCount } from '../../Models/Domains/Threads/ThreadCount';
import { ResultPageModel } from '../../Core/SortingAndPaging/Models/ResultPageModel';
import { ThreadResponse } from '../../Models/Domains/Threads/ThreadResponse';
import { ThreadQuery } from '../../Models/Domains/Threads/ThreadQuery';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class NotificationsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<ThreadCount, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Notifications/Notifications/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<ThreadCount, any>(url, data);
  }
  public post(query: ThreadQuery): Promise<ResultPageModel<ThreadResponse>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Notifications/Notifications/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query }

    return AjaxWrapper.post<ResultPageModel<ThreadResponse>, any>(url, data);
  }
  public put(query: ThreadResponse): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Notifications/Notifications/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query }

    return AjaxWrapper.put<ValidationStatus, any>(url, data);
  }
}

